import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-subtract",
  "use": "icon-subtract-usage",
  "viewBox": "0 0 18 2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 2\" id=\"icon-subtract\"><path d=\"M17.75.2H.25a.18.18 0 0 0-.178.178v1.25c0 .098.08.178.178.178h17.5c.099 0 .179-.08.179-.178V.378a.179.179 0 0 0-.179-.179z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol